/* eslint-disable react/prefer-es6-class, react/no-did-mount-set-state, react/sort-comp */
import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Keys from 'es6/core/keys';
import { t } from 'es6/services/localization';
import MouseoverDictionary from 'iknow-mouseover-dictionary/react';
import FitText from 'es6/components/common/fit-text';
import QuizStatus from 'es6/components/apps/sentence-builder/quiz-status';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import ResultGlyphs from 'es6/components/apps/result-glyphs';
import * as SoundEffects from 'es6/core/sound-effects';
import SoundManager from 'es6/services/sound-manager';
import SoundPlayer from 'es6/components/common/sound-player';
import { TranscodedImageSizes, TranscodedImage } from 'es6/components/common/transcoded-image';
import WordSlots from 'es6/components/apps/sentence-builder/word-slots';

/**
 * ItemPackages are expected to contain the memory field.
 */
export default React.createClass({
  displayName: 'SentenceBuilderConfirmationScreen',

  propTypes: {
    isCorrect: React.PropTypes.bool.isRequired,
    maxMistakes: React.PropTypes.number.isRequired,
    mistakes: React.PropTypes.number.isRequired,
    onNext: React.PropTypes.func.isRequired,
    wordSlots: React.PropTypes.array.isRequired,
    sentence: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      calculatedDisplaySize: false,
      isLargeDisplay: false,
    };
  },

  componentDidMount() {
    // Play sound effect.
    const soundEffect = this.props.isCorrect ? SoundEffects.SPELL_CORRECT : SoundEffects.SPELL_INCORRECT;
    SoundManager.playEffect(soundEffect, { finished: this._playSound });

    // Determine if word slots is a large display.
    const wordSlots = ReactDOM.findDOMNode(this).querySelector('.word-slots');
    const isLargeDisplay = wordSlots.scrollHeight > wordSlots.clientHeight;
    this.setState({ calculatedDisplaySize: true, isLargeDisplay });

    // Listen for user input.
    document.addEventListener('keydown', this._handleKeydown);
  },

  componentWillUnmount() {
    SoundManager.stop();

    document.removeEventListener('keydown', this._handleKeydown);
  },

  /**
   * Callback for keydown event.
   *
   * @param {Event} e
   */
  _handleKeydown(e) {
    const downKey = e.shiftKey && e.keyCode === Keys.DOWN;
    const spaceKey = e.keyCode === Keys.SPACE;

    if (downKey || spaceKey) {
      this._playSound();
    }
  },

  /**
   * Play the sentence sound.
   *
   * @param {Object} options
   */
  _playSound() {
    const sound = this.props.sentence.sound;

    if (sound) {
      SoundManager.play(sound);
    }
  },

  render() {
    let resultIconClassName;
    let message;

    const { isCorrect,
           maxMistakes,
           mistakes,
           sentence,
           wordSlots } = this.props;

    const { calculatedDisplaySize, isLargeDisplay } = this.state;

    if (!isCorrect) {
      message = t('too bad!');
      resultIconClassName = ResultGlyphs.INCORRECT;
    } else if (mistakes > 0) {
      message = t('almost');
      resultIconClassName = ResultGlyphs.CORRECT_WITH_MISTAKES;
    } else {
      message = t('js_iknow.well done!');
      resultIconClassName = ResultGlyphs.CORRECT;
    }

    const quizContentStyle = { visibility: calculatedDisplaySize ? 'visible' : 'hidden' };
    const quizContentClassName = classnames('quiz-content', {
      'quiz-content-large-display': isLargeDisplay,
    });

    return (
      <div className="screen screen-sentence-builder-confirmation">
        <div className="screen-content">
          <p className="message">{message}</p>

          <QuizStatus mistakes={mistakes} maxMistakes={maxMistakes} />

          <section className="quiz">
            <div className="result-icon">
              <div className={resultIconClassName} />
            </div>

            <div className={quizContentClassName} style={quizContentStyle}>
              <WordSlots data={wordSlots} />
            </div>
          </section>

          <div className="sentence-study-figure">
            <div className="sentence-content">
              <div className="primary-content">
                {this._renderSoundPlayer()}

                <div className="sentence-text">
                  {/* Set a key on the FitText forcing it to reshrink the font sizes if
                    the MouseoverDictionary text changes. */}
                  <FitText key={sentence.getText()}>
                    <MouseoverDictionary html={sentence.getText()} />
                  </FitText>
                </div>

                <div className="sentence-transliteration">
                  {sentence.getTransliteration() &&
                    <FitText key={sentence.getTransliteration()}>
                      <MouseoverDictionary html={sentence.getTransliteration()} />
                    </FitText>}
                </div>

                {this._renderTranslation()}
              </div>

              <aside className="secondary-content">
                {this._renderImage()}
              </aside>
            </div>
          </div>
        </div>

        <Navigation>
          <NavButton align="right" onClick={this.props.onNext} keyCode={Keys.ENTER} focused>{t('js_iknow.next')}</NavButton>
        </Navigation>
      </div>
    );
  },

  _renderImage() {
    const image = this.props.sentence.getImage();

    if (!image) {
      return null;
    }

    return (
      <TranscodedImage size={TranscodedImageSizes.APP_SENTENCE_SMALL} src={image} />
    );
  },

  _renderSoundPlayer() {
    const sound = this.props.sentence.sound;

    if (!sound) {
      return null;
    }

    return (<SoundPlayer source={sound} className="sentence-sound" />);
  },

  _renderTranslation() {
    const translation = this.props.sentence.getTranslation();

    if (!translation) {
      return null;
    }

    return (
      <div className="sentence-translation">
        <FitText><span dangerouslySetInnerHTML={{ __html: translation }} /></FitText>
      </div>
    );
  },
});
